import store from 'services/redux/store'
import { createDateHelper } from 'utils/date-helper'

export { dateFormat } from 'utils/date-helper'

export default createDateHelper( store.getState );
